<template functional>
    <portal-target :name="props.name" class="map-buttons is-hidden-print" :class="props.positionClass"></portal-target>
</template>
<script>
	export default {
		props: {
			positionClass: {
				type: String,
				default: 'top left'
			},
			name:{
				type: String,
				required:true
			}
		},

	};
</script>
<style lang="scss">
    @import '../../../assets/sass/main.scss';

    .map-buttons {
        z-index: 9999 !important;
        position: absolute !important;
    }

    .map-buttons button {
        width: 32px !important;
        height: 32px !important;;
        padding: 0 !important;;
        background-color: $white !important;
        display: block !important;
        border-radius: 0 !important;
        border-top-style: none !important;
        border-color: $blue !important;
    }
    
    .map-buttons button:first-of-type {
        border-top-left-radius: 4px !important;
        border-top-right-radius: 4px !important;
        border-top-style: solid !important;
    }

    .map-buttons button:last-of-type {
        border-bottom-left-radius: 4px !important;
        border-bottom-right-radius: 4px !important;
    }

    .map-buttons button.is-outlined:hover {
        background-color: $white-ter !important;
    }
        
    .map-buttons button.map-button-round{
        border-style: solid !important;
        border-radius: 4px !important;
    }

    .map-buttons *.map-button-round:not(:first-child){
        margin-top: 6px;
    }

    .map-buttons button.is-active{
        background-color: $blue !important;
    }

    .map-buttons button.is-active:hover {
        background-color: $blue !important;
    }

    .map-buttons.top {
        top: calc(#{$column-gap} +  20px)
    }

    .map-buttons.bottom {
        bottom: calc(#{$column-gap} +  20px);
    }

    .map-buttons.left {
        left: calc(#{$column-gap} +  20px);
    }

    .map-buttons.right {
        right: calc(#{$column-gap} +  20px);
    }
</style>